import { convexQuery } from "@convex-dev/react-query";
import { useQuery } from "@tanstack/react-query";
import { createFileRoute, useNavigate } from "@tanstack/react-router";

import { stationsGetById } from "~/api-refs";
import { EditStationContent } from "~/components/stations/station-edit-content";
import { isStationType } from "~/components/stations/station-edit-types";
import { Button } from "~/components/ui/button";
import { Skeleton } from "~/components/ui/skeleton";
import { toConvexTableId } from "~/lib/convex-table-id";

export const Route = createFileRoute(
  "/_authenticated/locations/$id/stations/$stationId/edit"
)({
  component: EditStationRoute,
});

function EditStationRoute() {
  const { id: locationId, stationId } = Route.useParams();
  const navigate = useNavigate();

  const { data: station, isLoading } = useQuery(
    convexQuery(stationsGetById, {
      id: toConvexTableId("stations", stationId),
    })
  );

  const handleClose = () => {
    void navigate({
      to: "/locations/$id/stations",
      params: { id: locationId },
    });
  };

  if (isLoading) {
    return <Skeleton className="h-96 w-full" />;
  }

  if (!station) {
    return (
      <div className="flex flex-col items-center justify-center py-12">
        <p className="text-muted-foreground">Station not found</p>
        <Button className="mt-4" onClick={handleClose} variant="outline">
          Back to Stations
        </Button>
      </div>
    );
  }

  if (!isStationType(station)) {
    return (
      <div className="flex flex-col items-center justify-center py-12">
        <p className="text-muted-foreground">Station not found</p>
        <Button className="mt-4" onClick={handleClose} variant="outline">
          Back to Stations
        </Button>
      </div>
    );
  }

  return <EditStationContent handleClose={handleClose} station={station} />;
}
